import type {
  NamedScriptInfo,
  NamedScriptLoadOptions,
  NamedScriptStrategy,
} from "./namedScriptLoad";
import { observeNamedScript } from "./namedScriptLoad";

export type EntryScriptStrategy = NamedScriptStrategy;
export type EntryScriptInfo = NamedScriptInfo;
export type EntryScriptLoadOptions = NamedScriptLoadOptions;

// Matches index.js, index.abc123.js, index-abc123.js — but NOT indexer.js.
// The optional group requires a `.` or `-` separator after "index".
const DEFAULT_ENTRY_PATTERN = /\/index([.\-][^/]+)?\.js$/i;

export function observeIndexScript(options: EntryScriptLoadOptions = {}): void {
  observeNamedScript(options, {
    defaultPattern: DEFAULT_ENTRY_PATTERN,
    hasStored: (ns) => ns.entryScriptResourceResponseEnd != null,
    store: (ns, chunk) => {
      ns.entryScriptResourceUrl = chunk.url;
      ns.entryScriptResourceStartTime = chunk.startTime;
      ns.entryScriptResourceResponseEnd = chunk.responseEnd;
    },
  });
}
